// extracted by mini-css-extract-plugin
module.exports = {"grid":"about-module--grid--3Nf-4","about":"about-module--about--10YF1","aboutImg":"about-module--about-img--1LcLd","aboutText":"about-module--about-text--2s4gb"};